import { render, staticRenderFns } from "./dialog-process-setting.vue?vue&type=template&id=6f0c1f45&scoped=true"
import script from "./dialog-process-setting.vue?vue&type=script&lang=js"
export * from "./dialog-process-setting.vue?vue&type=script&lang=js"
import style0 from "./dialog-process-setting.vue?vue&type=style&index=0&id=6f0c1f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c1f45",
  null
  
)

export default component.exports